import { IonContent, IonFooter, IonSkeletonText } from "@ionic/react";
import React from "react";

const Skeleton__OrderEntryModal: React.FC = () => {
  return (
    <>
      <IonContent>
        <div style={{ margin: "13px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
              height: "max-content",
            }}
          >
            <IonSkeletonText
              animated={true}
              style={{ width: "100%", height: "50px" }}
            ></IonSkeletonText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
              height: "max-content",
            }}
          >
            <IonSkeletonText
              animated={true}
              style={{ width: "25%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "25%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "25%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "25%", height: "50px" }}
            ></IonSkeletonText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
              height: "max-content",
            }}
          >
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
              height: "max-content",
            }}
          >
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
              height: "max-content",
            }}
          >
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
              height: "max-content",
            }}
          >
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "100%",
              height: "max-content",
            }}
          >
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "50%", height: "50px" }}
            ></IonSkeletonText>
          </div>
        </div>
      </IonContent>
      <IonFooter
        className="ion-no-border ion-padding"
        style={{ backgroundColor: "var(--ion-background-color)" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            width: "100%",
            height: "max-content",
          }}
        >
          <IonSkeletonText
            animated={true}
            style={{ width: "50%", height: "50px" }}
          ></IonSkeletonText>
          <IonSkeletonText
            animated={true}
            style={{ width: "50%", height: "50px" }}
          ></IonSkeletonText>
        </div>
      </IonFooter>
    </>
  );
};

export default Skeleton__OrderEntryModal;
